// This file is not yet translated.
/* eslint-disable i18next/no-literal-string */
import { PaymentRequestButtonElement } from "@stripe/react-stripe-js";
import * as StripeLib from "@stripe/stripe-js";
import * as React from "react";

type PaymentRequestButtonProps = {
  paymentRequest: StripeLib.PaymentRequest;
  handleClick?: () => void;
};

export default function PaymentRequestButton({
  paymentRequest,
  handleClick = () => null
}: PaymentRequestButtonProps) {
  return (
    <PaymentRequestButtonElement
      onClick={handleClick}
      options={{
        paymentRequest,
        style: {
          paymentRequestButton: {
            theme: "light-outline",
            height: "40px"
          }
        }
      }}
    />
  );
}
